import ScalarIconWarningOctagon_vue_vue_type_script_setup_true_lang_default from "./ScalarIconWarningOctagon.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarIconWarningOctagon.vue
var ScalarIconWarningOctagon_default = ScalarIconWarningOctagon_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconWarningOctagon_default as default };

//# sourceMappingURL=ScalarIconWarningOctagon.js.map